import { NgModule } from '@angular/core';
import { AbstractDebounceDirective } from './abstract-debounce.directive';
import { SrchDbounceDirective } from './srch-dbounce.directive';

const Directives = [
  SrchDbounceDirective,
  AbstractDebounceDirective
]

@NgModule({
  declarations: [...Directives],
  exports: [
    ...Directives
  ]
})
export class AbstractDebounceModule { }
